import { render, staticRenderFns } from "./DashboardOre.vue?vue&type=template&id=7abcea45&"
import script from "./DashboardOre.vue?vue&type=script&lang=js&"
export * from "./DashboardOre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports